<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-direction`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.847 40.962c-.676 1.66 1.004 3.302 2.648 2.589l12.21-5.294a2 2 0 011.59 0l12.21 5.294c1.644.713 3.324-.93 2.648-2.589l-13.8-33.91c-.677-1.662-3.03-1.662-3.706 0l-13.8 33.91zm25.814-2.994L24.5 33.562l-10.161 4.406L24.5 13l10.161 24.968z"/></svg>
</template>
<script>

export default {
  name: 'IconDirection',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
